import React from 'react';
import './Footer.css';

const Footer = () => {
  return (
    <div className="footer">
      <div className="footer-top">
        <div className="footer-top-socials">
          <i className="fa-brands fa-facebook-f"></i>
          <i className="fa-brands fa-twitter"></i>
          <i className="fa-regular fa-envelope"></i>
          <i className="fa-brands fa-linkedin-in"></i>
        </div>
        <div className="footer-main-content">
          <div className="footer-content">
            <div className="footer-content-heading">Address</div>
            <p className="footer-content-text">SK Classes Building, Kirti Nagar, <br></br>Lane No1, Opp. Krushna Chowk Bus Stop, New Sangavi,<br />Pimpri Chinchwad, Pune</p>
            <h2><a href="https://g.co/kgs/bgAcPTD">Get Directions 📍</a></h2>
          </div>
          <div className="footer-content">
            <div className="footer-content-heading">Phone Number</div>
            <a href="tel:08048060279" className="footer-content-text">08048060279</a>
          </div>
          <div className="footer-content">
            <div className="footer-content-heading">Email</div>
            <a href="mailto:doctorninaad@gmail.com" className="footer-content-text">doctorninaad@gmail.com</a>
          </div>
          
        </div>
      </div>
      <div className="footer-bottom">
        <div className="footer-bottom-left">
          <span>&copy;</span> 2024 Rights Reserved, Atharva Ayurved
        </div>
        <div className="footer-bottom-right">
          Built by Turing TechLabs
        </div>
      </div>
    </div>
  );
};

export default Footer;